
	<div
		class="dynamic-field form-group"
        [class.has-error]="isInvalid()">
		<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
		<label class="col-lg-3 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
			<i *ngIf="getHint()" class="fa fa-info-circle"
				tooltip="{{getHint()|translate}}"
				placement="top"
				triggers="click"
				containerClass="tig-tooltip"
				delay="50"></i>
	        <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
		<div class="col-lg-8">
			<ng-select
				[items]="ARR_options"
				[multiple]="(OBJ_field_config.multiple != null)?OBJ_field_config.multiple:true"
				[disabled]="OBJ_field_config?.readonly"
				(selected)="selected($event)"
				(removed)="removed($event)"
				(data)="refresh($event)"
				[placeholder]="'please_select'|translate"
				[allowClear]="true"
			></ng-select>
			 <span class="help-block m-b-none" *ngIf="isInvalid()">
                    {{'oError.sRequired'|translate}}
                </span>
		</div>
	</div>
	